@import '~style-sheet-helpers/core.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';
@import '../../../../../constants/spacing.module.less';

.doc-section {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: @space-12;
}

.doc-section-information {
  display: inline-flex;
  align-items: center;
  background: var(--default--background-color--2);
  color: var(--default--text-color--17);
  padding: @space-4;
  font-size: 12px;
  min-height: @space-32;
}

.doc-section-icon {
  height: 16px;
  min-width: 12px;
  min-height: 12px;
  fill: var(--primary--icon--background-color--1);
}

.doc-section-description {
  font-size: 14px;
  margin-left: @space-4;
  margin-right: @space-4;
}
